import axios from 'axios'

export const getDinas = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-dinas")
            .then((response) => {
                commit('SET_DINAS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}